import { validateNull } from './validate'
export const getEnv = () => {
  return (
    ['dev', 'test', 'pre'].find((v) => {
      return location.host.includes(v)
    }) || 'prod'
  )
}

export const getEnvName = () => {
  return (
    ['dev', 'test', 'pre'].find((v) => {
      return location.host.includes(v)
    }) || ''
  )
}
const envList = [
  { name: 'dev-edu', domain: 'zhixuehuijiao.cn' },
  { name: 'test', domain: 'zhixuehuijiao.cn' },
  { name: 'preprepare', domain: 'zhixuehuijiao.cn' },
]

export const getDomainByEnv = () => {
  const matchedEnv = envList.find((v) => location.host.includes(v.name))
  return matchedEnv ? matchedEnv.domain : 'zhixuehuijiao.cn'
}
export const getHostName = () => {
  let target = ''
  if (process.env.NODE_ENV === 'production') {
    const hosts = window.location.host.split('.').reverse()
    target = hosts.length > 1 ? `${hosts[1]}.${hosts[0]}` : 'zhixuehuijiao.cn'
  }
  return target
}

/**
 * 处理当前地址
 * @returns {String}
 */
export const hostUrl = () => {
  const env = getEnvName()
  // env为空是可能为localhost本地访问，如果包含deu则为正式环境
  const host = validateNull(env) && env.includes('edu') ? 'edu-' : 'test'
  return env === 'preprepare' ? 'pre' : host
}
const userAgent = window?.navigator?.userAgent
const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
export const isTeacherPad = isAndroid && userAgent.indexOf('zxhjTeacherApk') > -1 // 是不是教师端平板端
export const isStudentPad = isAndroid && userAgent.indexOf('zxhjStudentApk') > -1 // 是不是学生端平板端
export const isPad = isAndroid && userAgent.indexOf('zxhj') > -1 // 是不是课堂互动平板端
